var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSettingActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.814,
    height: 20,
    viewBox: "0 0 18.814 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.027,
    x2: 1,
    y2: 0.91,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d0b77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5fa2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_313",
    "data-name": "Subtraction 313",
    d: "M18930.244,7103h-1.682a2.425,2.425,0,0,1-2.42-2.424v-.86l-.057-.028a5.673,5.673,0,0,1-.812-.466l-.057-.033-.742.432a2.367,2.367,0,0,1-1.2.319,2.471,2.471,0,0,1-2.109-1.208l-.832-1.464a2.423,2.423,0,0,1,.879-3.3l.689-.395.053-.033-.006-.067a5.3,5.3,0,0,1,0-.932l.006-.066-.742-.428a2.422,2.422,0,0,1-.889-3.313l.842-1.459a2.466,2.466,0,0,1,2.109-1.208,2.367,2.367,0,0,1,1.2.319l.689.4.053.033.057-.038a6.471,6.471,0,0,1,.813-.466l.057-.033v-.856a2.425,2.425,0,0,1,2.42-2.424h1.682a2.427,2.427,0,0,1,2.424,2.424v.856l.053.033a7.175,7.175,0,0,1,.818.456l.053.033.736-.428a2.447,2.447,0,0,1,3.316.889l.842,1.459a2.431,2.431,0,0,1-.889,3.313l-.689.395-.053.033v.066a4.689,4.689,0,0,1,0,.937v.057l.742.433a2.452,2.452,0,0,1,1.131,1.474,2.419,2.419,0,0,1-.242,1.839l-.842,1.459a2.422,2.422,0,0,1-1.473,1.126,2.358,2.358,0,0,1-.633.086,2.414,2.414,0,0,1-1.207-.323l-.684-.4-.057-.033-.053.038a8.371,8.371,0,0,1-.818.466l-.053.028v.86A2.427,2.427,0,0,1,18930.244,7103Zm-.836-14.111a4.109,4.109,0,1,0,4.1,4.111A4.116,4.116,0,0,0,18929.408,7088.889Zm0,6.74a2.626,2.626,0,1,1,2.623-2.628A2.632,2.632,0,0,1,18929.408,7095.629Z",
    transform: "translate(-18919.998 -7083)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingActive);
export default __webpack_public_path__ + "static/media/icon-setting-active.551cd710fed7c8272de998b4deac0486.svg";
export { ForwardRef as ReactComponent };